import { render } from "./Location.vue?vue&type=template&id=2c9c7736&scoped=true"
import script from "../js/location.js?vue&type=script&lang=js"
export * from "../js/location.js?vue&type=script&lang=js"

import "./Location.vue?vue&type=style&index=0&id=2c9c7736&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9c7736"]])

export default __exports__